import { IMenuOrders } from './menu-order';

export interface IMenuOrdersResponse {
  footer: IMenuOrders[];
  menu_top: IMenuOrders[];
}
